import EmptyContainerSvg from "%/dynamic-components/builder-engine/assets/empty-container.svg";

const RIGHT_ARROW = "<svg width=\"1em\" height=\"1em\" fill=\"currentColor\" class=\"bi bi-arrow-right text-8xl text-stone-800 dark:text-stone-200\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" d=\"M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8\"></path></svg>";
const DOWN_ARROW = "<svg width=\"1em\" height=\"1em\" fill=\"currentColor\" class=\"bi bi-arrow-down text-8xl text-stone-800 dark:text-stone-200\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" d=\"M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1\"></path></svg>";

const ChildTrackingMixin = {
  data() {
    return {
      stopTracking: null,
      ignoreClasses: ["empty-layout-ghost", "action-buttons"],
    };
  },
  computed: {
    activeLayout() {
      const layoutOptionKey = this.getOptionClassForLayoutDirection();
      return this.getOptionValue(layoutOptionKey);
    },
    isEmpty() {
      return this.dynamicComponentInstance.getElementChildren(this.identifier)?.length === 0;
    },
    layoutWidth() {
      const [state, breakpoint] = this.activeState.split(":");
      return this.dynamicComponentInstance.getRawOptionValue(
        this.identifier,
        "layout-width",
        breakpoint,
        state,
      )?.r;
    },
    layoutHeight() {
      const [state, breakpoint] = this.activeState.split(":");
      return this.dynamicComponentInstance.getRawOptionValue(
        this.identifier,
        "layout-height",
        breakpoint,
        state,
      )?.r;
    },
  },
  watch: {
    isEmpty: {
      handler() {
        if (this.editMode) {
          this.handleChildChanged();
        }
      },
    },
    layoutHeight: {
      immediate: true,
      handler() {
        if (this.editMode) {
          this.handleGhostScale();
        }
      },
    },
    layoutWidth: {
      immediate: true,
      handler() {
        if (this.editMode) {
          this.handleGhostScale();
        }
      },
    },
    activeLayout(newValue) {
      const ghostElement = this.$el.querySelector(`.empty-layout-ghost[id='${this.identifier}']`);

      if (ghostElement) {
        const ghostIcon = ghostElement.querySelector(".empty-layout-ghost-icon");
        if (newValue === "vertical") {
          ghostElement.classList.add("vertical");
          ghostElement.classList.remove("horizontal");
          ghostIcon.innerHTML = DOWN_ARROW;
        } else {
          ghostElement.classList.add("horizontal");
          ghostElement.classList.remove("vertical");
          ghostIcon.innerHTML = RIGHT_ARROW;
        }
      }
    },
  },
  mounted() {
    this.attachGhostIfEmpty();

    if (this.editMode) {
      this.stopTracking = this.trackChildChanges(this.$el, () => {
        this.attachGhostIfEmpty();
      });

      this.observeParentMutations();
    }
  },
  beforeUnmount() {
    if (this.stopTracking) {
      this.stopTracking();
    }

    if (this.parentObserver) {
      this.parentObserver.disconnect();
    }
  },
  methods: {
    attachGhostIfEmpty() {
      if (!this.editMode || !this.isEmpty) {
        return;
      }

      const existingGhost = this.$el.querySelector(`.empty-layout-ghost[id='${this.identifier}']`);
      if (existingGhost) {
        return;
      }

      this.addEmptyLayoutBackground();
      this.handleGhostScale();
    },
    observeParentMutations() {
      const parent = this.$el.parentNode;
      if (!parent) {
        return;
      }

      this.parentObserver = new MutationObserver(() => {
        if (
          this.isEmpty &&
            this.activeLayout &&
            !this.$el.querySelector(
              `.empty-layout-ghost[id='${this.identifier}']`,
            )
        ) {
          this.attachGhostIfEmpty();
        }
      });

      this.parentObserver.observe(parent, {
        childList: true,
        subtree: true,
      });
    },
    getOptionClassForLayoutDirection() {
      const bundlesAndOptions = this.dynamicComponentInstance.getAllOptionClassesForElement(
        this.dynamicComponentInstance.getElementType(this.identifier),
      );

      return bundlesAndOptions.find(option => option.optionKey === "layout-direction" ||
          option.optionKey === "static-layout-direction");
    },
    trackChildChanges(element, onChange) {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (this.ignoreClasses.some(className => Array.from(node.classList).includes(className))) {
                  return;
                }
                onChange(node);
              }
            });
            mutation.removedNodes.forEach(node => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (this.ignoreClasses.some(className => Array.from(node.classList).includes(className))) {
                  return;
                }
                onChange(node);
              }
            });
          }
        });
      });

      observer.observe(element, { childList: true });

      return () => {
        observer.disconnect();
      };
    },
    handleChildChanged() {
      if (this.isEmpty && this.editMode) {
        this.addEmptyLayoutBackground();
      } else {
        if (this.myBackgroundImage) {
          this.$el.style.backgroundImage = `url(${this.myBackgroundImage})`;
        } else {
          this.$el.style.backgroundImage = "unset";
        }

        Array.from(this.$el.children).forEach(child => {
          if (child.classList.contains("empty-layout-ghost")) {
            child.remove();
          }
        });
      }
    },
    handleGhostScale() {
      setTimeout(() => {
        const domElement = this.$el;
        const ghostElement = this.$el.querySelector(".i-dnd > .empty-layout-ghost[id='" + this.identifier + "']");

        if (!domElement || !ghostElement) {
          return;
        }

        const elementStyle = window.getComputedStyle(domElement);
        const myDomElementHeight = parseInt(elementStyle.height.replace("px", ""));
        const myDomElementWidth = parseInt(elementStyle.width.replace("px", ""));

        const minDimension = Math.min(myDomElementHeight, myDomElementWidth);
        const scalePercentage = minDimension / 100;
        const reducedScale = scalePercentage - 0.25;
        const scale = Math.max(0, reducedScale);

        if (minDimension < 120) {
          ghostElement.style.transform = `scale(${scale})`;
        } else {
          ghostElement.style.transform = "scale(1)";
        }
      }, 100);
    },
    addEmptyLayoutBackground() {
      this.$el.style.backgroundImage = `url(${this.myBackgroundImage || EmptyContainerSvg})`;
      this.$el.style.backgroundSize = "cover";

      const ghostElement = document.createElement("div");
      ghostElement.classList.add("empty-layout-ghost");
      ghostElement.id = this.identifier;

      const ghostElementText = document.createElement("div");
      ghostElementText.classList.add("empty-layout-ghost-text");
      ghostElementText.innerText = "Drop Here";

      const ghostElementIcon = document.createElement("div");
      ghostElementIcon.classList.add("empty-layout-ghost-icon");

      const layout = this.activeLayout || "horizontal";

      if (layout === "vertical") {
        ghostElement.classList.add("vertical");
        ghostElement.classList.remove("horizontal");
        ghostElementIcon.innerHTML = DOWN_ARROW;
      } else {
        ghostElement.classList.add("horizontal");
        ghostElement.classList.remove("vertical");
        ghostElementIcon.innerHTML = RIGHT_ARROW;
      }

      ghostElement.appendChild(ghostElementText);
      ghostElement.appendChild(ghostElementIcon);

      ghostElement.style.pointerEvents = "none";

      let hasGhost = false;
      Array.from(this.$el.children).forEach(child => {
        if (child.classList.contains("empty-layout-ghost")) {
          hasGhost = true;
        }
      });

      if (!hasGhost) {
        this.$el.appendChild(ghostElement);
        this.$el.style.backgroundImage = `url(${this.myBackgroundImage || EmptyContainerSvg})`;
        this.$el.style.backgroundSize = "cover";
      } else {
        this.handleGhostScale();
      }
    },
  },

};

export { ChildTrackingMixin };
